export const getPropName = (propName) => {
  let input = propName;
  if (propName.startsWith('data-')) {
    input = propName.substr('data-'.length);
  }
  return input.toLowerCase().replace(/-(.)/g, function(match, group1) {
    return group1.toUpperCase();
  });
};

export const extractPropsFromDataset = (attribs, overrides) => {
  const props = {};
  Object.keys(attribs).filter(k => k.startsWith('data-')).forEach(
    key => {
      props[(overrides && overrides[key]) || getPropName(key)] = attribs[key];
      delete attribs[key];
    });
  return props;
};

export const extractEvents = (attribs, onInternalEvent, values) => {
  let events = {};
  if (attribs['data-onclick-event']) {
    let name = attribs['data-onclick-event'];
    events.onClick = () => onInternalEvent(name, values);
    delete attribs['data-onclick-event'];
  }
  if (attribs['data-onhover-event']) {
    let name = attribs['data-onhover-event'];
    events.onHover = () => onInternalEvent(name, values);
    delete attribs['data-onhover-event'];
  }
  return events;
}

export const extractValuesEvents = (attribs, onInternalEvent) => {
  let events = {};
  if(onInternalEvent) events.onInternalEvent = onInternalEvent;
  if(attribs['data-onclick-event']){
    let name = attribs['data-onclick-event'];
    events.onClickEvents = name;
    delete attribs['data-onclick-event'];
  }
  if(attribs['data-onhover-event']){
    let name = attribs['data-onhover-event'];
    events.onHoverEvents = name;
    delete attribs['data-onhover-event'];
  }
  if(attribs['data-onselect-event']){
    let name = attribs['data-onselect-event'];
    events.onSelectEvents = name;
    delete attribs['data-onselect-event'];
  }
  if(attribs['data-oncheck-event']){
    let name = attribs['data-oncheck-event'];
    events.onCheckEvents = name;
    delete attribs['data-oncheck-event'];
  }
  return events;
}